export default __webpack_public_path__ + "29b5006545d0dba528516f034097700b.svg";